export type UserProfile = {
  id: string;
  firstName: string;
  lastName: string;
  forgerockId: string;
  sourceName: string;
  sdpPod: any;
  sdpRegion: any;
  sdpRestrictionLevel: any;
  sdps: string[];
};

export const UserInfoMap = {
  sdpRestrictionLevel: 'Restriction Level',
  sdpPod: 'POD',
  sourceName: 'SDP Id',
};
